import { render } from "./ModalAvisoSemAcesso.vue?vue&type=template&id=1d5755e3&scoped=true"
import script from "./ModalAvisoSemAcesso.vue?vue&type=script&lang=js"
export * from "./ModalAvisoSemAcesso.vue?vue&type=script&lang=js"

import "./ModalAvisoSemAcesso.vue?vue&type=style&index=0&id=1d5755e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5755e3"]])

export default __exports__